<template>
  <div class="assignRole">
    <el-dialog
      :title="$t('account.assignRoleTitle')"
      :visible.sync="dialogDetail"
      :close-on-click-modal="false"
      width="55%"
    >
      <div class="sirui-search" ref="sub">
        <el-form label-position="right" label-width="auto" :model="query" ref="queryFrom">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('role.search.applicationName')" prop="applicationCode">
                <el-select
                  style="width: 100%"
                  v-model="query.applicationCode"
                  :placeholder="$t('role.search.applicationPlaceholder') || $t('search.choose')"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in applicationList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('role.search.roleName')" prop="roleName">
                <el-input
                  style="width: 100%"
                  v-model="query.roleName"
                  :placeholder="$t('role.search.rolePlaceholder') || $t('search.input')"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="text-align: right">
              <el-button type="primary" @click="search()">{{ $t('search.search') }}</el-button>
              <el-button @click="resetForm('queryFrom')">{{ $t('search.reset') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!--内容区域-->
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :buttonList="[]"
          :loading="load"
          :data="tableData"
          :paging="false"
          :reserve="false"
          :setting="false"
          rowKey="roleCode"
          maxHeight="410"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :width="item.width"
            :sortable="item.sortable"
            :field="item.prop"
            :title="item.label"
          ></vxe-table-column>
        </sirui-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogDetail = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import ROLEAPI from '@/api/systemManage/role.js';
  import API from '@/api/systemManage/account.js';
  import SiruiTable from '@/components/SiruiTable';
  // import SiruiSearch from '@/components/SiruiSearch';

  export default {
    name: 'assignRole',
    components: {
      SiruiTable,
      // SiruiSearch,
    },
    data() {
      return {
        dialogDetail: false,
        load: false,
        loading: false,
        query: {
          applicationCode: null,
          roleName: null,
        },
        applicationList: [],
        tableData: [],
        checkRowKeys: [],
        selectRoleId: [],
        multipleSelection: [],
        userCode: '',
      };
    },
    computed: {
      //表格显示字段
      columnList() {
        return [
          { prop: 'roleName', label: this.$t('role.table.roleName') },
          {
            prop: 'applicationName',
            label: this.$t('role.table.applicationName'),
          },
          { prop: 'remark', label: this.$t('role.table.remark') },
        ];
      },
    },
    methods: {
      openDialog(flag, val) {
        this.dialogDetail = flag;
        this.loading = false;
        this.selectRoleId = [];
        this.multipleSelection = [];
        // this.$refs.siruiTable.clearCheckboxReserve();
        this.userCode = val;
        this.$nextTick(() => {
          this.queryApplication();
          this.getRoleHasChoose();
        });
      },
      //获取应用列表
      queryApplication() {
        this.$axios.post(ROLEAPI.GET_APP_LIST_API).then((res) => {
          if (0 == res.data.code) {
            res.data.data.forEach((item) => {
              item.label = item.applicationName;
              item.value = item.applicationCode;
            });
            this.applicationList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取数据
      // getData() {
      //   const query = this.query;
      //   query.pageSize = this.$refs.siruiTable.page.pageSize;
      //   query.pageNum = this.$refs.siruiTable.page.pageNum;
      //   this.load = true;
      //   this.$axios.post(ROLEAPI.GET_LIST_API, query).then(res => {
      //     this.load = false;
      //     if (0 == res.data.code) {
      //       this.tableData = res.data.data.list;
      //       this.$refs.siruiTable.setPageTotal(res.data.data.total);
      //     } else {
      //       this.$alert(res.data.msg);
      //     }
      //   });
      // },
      //当前页面已有角色
      getRoleHasChoose() {
        const query = this.query;
        query.userCode = this.userCode;
        this.checkRowKeys = [];
        this.$refs.siruiTable.clearSelectRecord();
        this.$axios.post(API.GET_LIST_ROLE_API, query).then((res) => {
          if (0 == res.data.code) {
            // 表格塞值
            this.tableData = res.data.data.all;
            //设置选中
            res.data.data.checked.forEach((item) => {
              this.checkRowKeys.push(item.roleCode);
            });
            let rows = [];
            this.tableData.map((it) => {
              if (this.checkRowKeys.indexOf(it.roleCode) != -1) {
                rows.push(it);
              }
            });
            this.$nextTick(() => {
              this.$refs.siruiTable.clearSelectRecord();
              this.$refs.siruiTable.setCheckboxRow(rows, true);
            });
            //将选中的id存起来
            this.selectRoleId = this.checkRowKeys;
            //this.getRoleHasChoose();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.getRoleHasChoose();
      },
      //重置
      resetForm(from) {
        this.$refs[from].resetFields();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getRoleHasChoose();
      },
      //每页条数
      handleSizeChange() {
        this.getRoleHasChoose();
      },
      //第几页
      handleCurrentChange() {
        this.getRoleHasChoose();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
        let roleCode = [];
        this.multipleSelection.forEach((item) => {
          roleCode.push(item.roleCode);
        });
        //将选中的id存起来
        this.selectRoleId = roleCode;
      },
      //保存
      addSure() {
        const params = {
          userCode: this.userCode,
          roleList: this.selectRoleId.length == 0 ? null : this.selectRoleId,
        };
        if (!this.loading) {
          this.loading = true;
          this.$axios.post(API.ADD_ASSIGN_ROLE_API, params).then((res) => {
            this.loading = false;
            if (0 != res.data.code) {
              this.$alert(res.data.msg);
            } else {
              this.dialogDetail = false;
              this.$emit('getData');
              this.$message({
                showClose: true,
                message: res.data.msg || this.$t('message.success'),
                type: 'success',
              });
            }
          });
        }
      },
    },
  };
</script>
